angular.module('unica_invitation_list.invitation_list_services')

.factory('InvitationListListService', function ($http, getBaseApiURL, $rootScope) {


	var invitationListListService = {};


	invitationListListService.list = function (eventId, limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/list/' + eventId,
			data: {
				limit: limit,
				offset: offset
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_lists;
			}

		});
	};

	invitationListListService.fullList = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/full-list/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_lists;
			}

		});
	};

	invitationListListService.get = function (invitationListId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/detail/' + invitationListId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_list;
			}

		});
	};


	invitationListListService.exportInvitationList = function (invitationListId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/invitation-list/' + invitationListId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};



	invitationListListService.exportAvatarZip = function (eventId, invitationListId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/picture/' + eventId + ( invitationListId ? '/' + invitationListId : '' ),
			data: { }
		}).then(function(result) {

			if ( result ) {
				if ( result.data.result == 'ok' ) {
					return result.data.url;
				} else {
					$rootScope.showWarningMsg( result.data.message );
				}
			}

		});
	};


	invitationListListService.exportCustomFieldZip = function (eventFieldId, invitationListId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/field/' + eventFieldId + ( invitationListId ? '/' + invitationListId : '' ),
			data: { }
		}).then(function(result) {

			if ( result ) {
				if ( result.data.result == 'ok' ) {
					return result.data.url;
				} else {
					$rootScope.showWarningMsg( result.data.message );
				}
			}

		});
	};


	return invitationListListService;
});